// components
import { Navbar, Footer } from "@/components";

// sections
import { SocialRides } from "@/components/social-rides";

export default function SocialRidesPage() {
  return (
    <>
      <Navbar />
      <SocialRides />
      <Footer />
    </>
  );
}
